(function () {
  function addMonths(baseDate, months) {
    var d = new Date(baseDate.getTime());
    d.setMonth(d.getMonth() + months);
    return d;
  }

  function isDismissed(storageKey) {
    try {
      var raw = localStorage.getItem(storageKey);
      if (!raw) return false;

      if (raw[0] === "{") {
        var parsed = JSON.parse(raw);
        if (!parsed || !parsed.expiresAt) return false;
        return Date.now() < Number(parsed.expiresAt);
      }

      var expiresAtLegacy = Number(raw);
      if (Number.isFinite(expiresAtLegacy)) {
        return Date.now() < expiresAtLegacy;
      }

      return false;
    } catch (e) {
      return false;
    }
  }

  function setDismissed(storageKey, hideMonths) {
    try {
      var expiresAt = addMonths(new Date(), hideMonths).getTime();
      localStorage.setItem(
        storageKey,
        JSON.stringify({
          closedAt: Date.now(),
          expiresAt: expiresAt,
        })
      );
    } catch (e) {}
  }

  function initPopup(sectionEl) {
    var modalId = sectionEl.getAttribute("data-modal-id");
    var delaySeconds = Number(sectionEl.getAttribute("data-delay-seconds") || 10);
    var hideMonths = Number(sectionEl.getAttribute("data-hide-months") || 6);
    var storageKey = "newsletter_popup_closed_v1";

    if (!modalId || typeof window.MicroModal === "undefined") return;
    if (isDismissed(storageKey)) return;

    window.MicroModal.init({
      disableScroll: true,
    });

    setTimeout(function () {
      if (!isDismissed(storageKey)) {
        window.MicroModal.show(modalId, {
          disableScroll: true,
          onClose: function () {
            setDismissed(storageKey, hideMonths);
          },
        });
      }
    }, delaySeconds * 1000);
  }

  function boot() {
    document.querySelectorAll(".newsletter-popup-section").forEach(initPopup);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();